import { render, staticRenderFns } from "./BrConfirmSubmit.vue?vue&type=template&id=dc2234f6&"
import script from "./BrConfirmSubmit.vue?vue&type=script&lang=js&"
export * from "./BrConfirmSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports